import React from 'react';
import { useTranslation } from 'react-i18next';

const GuestsDetailsInformation = ({ guestsInfo }) => {
  const [t] = useTranslation();

  return (
    <div>
      {guestsInfo
        .map(guests => {
          return `${guests.guestsNumber.toString()} 
                               ${t(guests.participant[0].participant)}`;
        })
        .join(' ⋅ ')}
    </div>
  );
};

export default GuestsDetailsInformation;
